import { render, staticRenderFns } from "./ResourcesTraining.vue?vue&type=template&id=59bc822f&"
import script from "./ResourcesTraining.vue?vue&type=script&lang=js&"
export * from "./ResourcesTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports